import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const IQACCoreCommitteMembers = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [framework, setFramework] = useState(false);
  const [three, setThree] = useState(false);
  const [four, setFour] = useState(false);
  const [five, setFive] = useState(false);
  const [six, setSix] = useState(false);
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="ccm-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">IQAC Core Committe Members</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2018 - 2019
        </button>
        {isOpen && (
          <div className="obj-items">
            <h3>Chairman</h3>
            <p>✬ Dr. A. Abdul Jabbar - Principal & Chairman</p>
            <p></p>
            <h3>Coordinator</h3>
            <p>
              ✬ Mr. S. A. Sheik Mohamed - Associate Professor, Department of
              English
            </p>
            <p></p>
            <h3>Members</h3>
            <p>✬ Dr. S. Basheer Ahamed - Vice Principal (Academics)</p>
            <p>✬ Mr. M. Zahiruddin Sheriff - Vice Principal (Administration)</p>
            <p>✬ Mr. A.R. Abdul Lathif - Controller of Examinations</p>
            <p>✬ Mr. K.S. Md. Akmal - Secretary, College Council</p>
            <p>✬ Mr. D. Burhanuddin Dulvi - Vice President, Student Union</p>
            <p>✬ Dr. V. Kamal Nasir -Deputy Warden</p>
            <p>
              ✬ Dr. G. Shaik Abdul Wahab - Associate Professor, Department of
              English
            </p>
            <p>✬ Dr. A. Abdul Raheem - Research Coordinator</p>
            <p>
              ✬ Dr. Anvar Sadhath Valiyaparambath Valiyaparambath-Placement
              Officer
            </p>
            <p>✬ Dr. P. Hakkim Divan Mydeen - Head, CIC</p>
            <p>
              ✬ Dr. Mohammed Ibrahim Naveed - Associate Professor, Coordinator,
              UGC Grants & Funds
            </p>
            <p>
              ✬ Dr. A. Hyder Ali - Assistant Professor, Department of Zoology
            </p>
            <p>
              ✬ Dr. M. Abdul Jamal - Assistant Professor, Department of
              Economics
            </p>
            <p>
              ✬ Mr. M. Ansar - Assistant Professor, Department of Corporate. Sec
            </p>
            <p>
              ✬ Dr. S. Thothadri - Assistant Professor, Department of Commerce
            </p>
            <p>
              ✬ Mr. R. Sivakumar - Assistant Professor, Department of Business
              Administration
            </p>
            <p>
              ✬ Mr. M. Md. Khaleelur Rahman - Assistant Professor, Department of
              English
            </p>
            <p>
              ✬ Mr. Syed Shakir Razvi - Assistant Professor, Department of
              Corporate. Sec
            </p>
            <p>✬ Mr. S. M. Mohamed Lukman - Librarian</p>
            <p>
              ✬ Dr. U. Muhammed Rafi - Assistant Professor, Department of
              Chemistry
            </p>
            <p>
              ✬ Mr. F. Mohamed Illyas – Vice President, Students’ Union (Shift
              II)
            </p>
            <p>✬ Mr. U. Mahaboob Basha - Director of Physical Education</p>
            <p>✬ Mr. M.H. Rasool Mohideen, Superintendent</p>
            <p></p>
            <h3>One Member from the Management</h3>
            <p> ✬ Mr. Asfaque Mecca – Executive Committee Member, MEASI</p>
            <p></p>
            <h3>One/two nominees from Alumni</h3>
            <p> ✬ Dr. K. Altaff - Professor Emeritus (Zoology)</p>
            <p> ✬ Mr. A. Imtiaz Ahmed - Executive Committee Member, MEASI</p>
            <p></p>
            <h3>
              One/two nominees from Employers / Industrialist / stakeholders
            </h3>
            <p> ✬ Mr. Elias Sait - Industrialist/ Businessman</p>
            <p> ✬ Mr. K. Allaudin, Indian Administrative Services</p>
            <p></p>
            <h3>One/ two nominees from among Students</h3>
            <p> ✬ Student Chairman, Shift-I</p>
            <p> ✬ Student Chairman, Shift-II</p>
            <p></p>
            <h3>Technical Assistant</h3>
            <p>✬ Mr. M. Thameemul Ansari</p>
          </div>
        )}

        <button
          onClick={() => setFramework((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2019 - 2020
        </button>
        {framework && (
          <div className="obj-items">
            <h3>Chairman</h3>
            <p>✬ Dr. A. Abdul Jabbar - Principal & Chairman</p>
            <p></p>
            <h3>Coordinator</h3>
            <p>
              ✬ Mr. S. A. Sheik Mohamed - Associate Professor, Department of
              English
            </p>
            <p></p>
            <h3>Members</h3>
            <p>✬ Dr. S. Basheer Ahamed - Vice Principal (Academics)</p>
            <p>✬ Mr. M. Zahiruddin Sheriff - Vice Principal (Administration)</p>
            <p>✬ Mr. A.R. Abdul Lathif - Controller of Examinations</p>
            <p>✬ Dr. T. Abdul Khadar - Vice President , Student Union</p>
            {/* <p>
                ✬ Mr. D. Burhanuddin Dulvi - Vice President, Student Union</p> */}
            <p>✬ Dr. V. Kamal Nasir -Deputy Warden</p>
            <p>
              ✬ Dr. G. Shaik Abdul Wahab - Associate Professor, Department of
              English
            </p>
            <p>✬ Dr. A. Abdul Raheem - Research Coordinator</p>
            <p>
              ✬ Dr. Anvar Sadhath Valiyaparambath Valiyaparambath-Placement
              Officer
            </p>
            <p>✬ Dr. P. Hakkim Divan Mydeen - Head, CIC</p>
            <p>
              ✬ Dr. Mohammed Ibrahim Naveed - Associate Professor, Coordinator,
              UGC Grants & Funds
            </p>
            <p>
              ✬ Dr. A. Hyder Ali - Assistant Professor, Department of Zoology
            </p>
            <p>
              ✬ Dr. M. Abdul Jamal - Assistant Professor, Department of
              Economics
            </p>
            <p>
              ✬ Mr. M. Ansar - Assistant Professor, Department of Corporate. Sec
            </p>
            <p>
              ✬ Dr. S. Thothadri - Assistant Professor, Department of Commerce
            </p>
            <p>
              ✬ Mr. R. Sivakumar - Assistant Professor, Department of Business
              Administration
            </p>
            <p>
              ✬ Mr. M. Md. Khaleelur Rahman - Assistant Professor, Department of
              English
            </p>
            <p>
              ✬ Mr. Syed Shakir Razvi - Assistant Professor, Department of
              Corporate. Sec
            </p>
            <p>✬ Mr. S. M. Mohamed Lukman - Librarian</p>
            <p>
              ✬ Dr. U. Muhammed Rafi - Assistant Professor, Department of
              Chemistry
            </p>
            <p>✬ Dr. N.O. Ariff – Vice President, Students’ Union (Shift II)</p>
            <p>✬ Mr. U. Mahaboob Basha - Director of Physical Education</p>
            <p>✬ Mr. M.H. Rasool Mohideen, Superintendent</p>
            <p></p>
            <h3>One Member from the Management</h3>
            <p> ✬ Mr. Asfaque Mecca – Executive Committee Member, MEASI</p>
            <p></p>
            <h3>One/two nominees from Alumni</h3>
            <p> ✬ Dr. K. Altaff - Professor Emeritus (Zoology)</p>
            <p> ✬ Mr. A. Imtiaz Ahmed - Executive Committee Member, MEASI</p>
            <p></p>
            <h3>
              One/two nominees from Employers / Industrialist / stakeholders
            </h3>
            <p> ✬ Mr. Elias Sait - Industrialist/ Businessman</p>
            <p> ✬ Mr. K. Allaudin, Indian Administrative Services</p>
            <p></p>
            <h3>One/ two nominees from among Students</h3>
            <p> ✬ Student Chairman, Shift-I</p>
            <p> ✬ Student Chairman, Shift-II</p>
            <p></p>
            <h3>Technical Assistant</h3>
            <p>✬ Mr. M. Thameemul Ansari</p>
          </div>
        )}

        <button
          onClick={() => setThree((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2020-2021
        </button>
        {three && (
          <div className="obj-items">
            <h3>Chairperson: Head of the Institution</h3>
            <p>✬ Dr. S. Basheer Ahamed, Principal</p>
            <p></p>
            <h3>Teachers to represent all level</h3>
            <p>✬ Dr. G. Shaik Abdul Wahab, Associate Professor of English</p>

            <p>
              ✬ Dr. T. Abdul Khadar, Associate Professor of Historical Studies
            </p>
            <p>✬ Dr. Mohammed Ibrahim Naveed, Associate Professor of Zoology</p>
            <p>✬ Dr. S. Thothadri, Assistant Professor of Commerce</p>
            <p>✬ Dr. J. Sulaiman, Assistant Professor of Commerce</p>
            {/* <p>
                ✬ Mr. D. Burhanuddin Dulvi - Vice President, Student Union</p> */}
            <p>✬ Dr. M. Abdul Jamal, Assistant Professor of Economics</p>
            <p>
              ✬ Mr. R. Sivakumar, Assistant Professor of Business Administration
            </p>
            <p>
              ✬ Dr. Syed Shakir Razvi, Assistant Professor of Corporate
              Secretaryship
            </p>
            <p>✬ Dr. U. Muhammed Rafi, Assistant Professor of Chemistry</p>
            <p>✬ Dr. A. Shahul Hameed, Assistant Professor of English</p>
            <p>
              ✬ Mr. S. K. Akbar Basha, Assistant Professor of Computer Science
            </p>
            <p>✬ Dr. M. R. Thameem Ansari, Assistant Professor of Arabic</p>
            <p>✬ Mr. S.M. Mohamed Lukman, Librarian</p>
            <p>✬ Dr. U. Mahaboob Basha, Director of Physical Education</p>

            <p></p>
            <h3>One member from the Management</h3>
            <p>✬ Mr. Elias Sait, Hon. Secretary</p>
            <p></p>
            <h3>Few Senior administrative officers</h3>
            <p>✬ VP Academic - Prof. S.A. Sheik Mohamed</p>
            <p>✬ VP Admin - Dr. V. Kamal Nasir</p>
            <p>✬ COE - Prof. A.R. Abdul Lathif</p>
            <p>✬ Bursar- Dr. S. Syed Rafiq Ahmed</p>
            <p>✬ Dean of Arts - Dr.S. Mohamed Abdul Razak</p>
            <p>✬ Dean of Science - Dr. M.A. Mohamed Musthafa</p>
            <p>✬ Dean of Commerce - Prof. K.S. Md Akmal</p>
            <p>✬ Dean of Research - Dr. M. Gulam Mohamed</p>
            {/* <p></p>
              <h3>One Member from the Management</h3> */}
            <p> ✬ Dean of Student Affairs - Dr. P. Gavuthu Meeran</p>

            <p>✬ Deputy Warden - Dr. A. Hyder Ali</p>
            <p> ✬ Placement Officer - Dr. M. . Ansar</p>
            <p> ✬ Office Superintendent - Mr. M.H. Rasool Mohideen</p>
            <p></p>
            <h3>One nominee each from local society, Students and Alumni</h3>
            <p> ✬ Alumnus- Mr. M. Zahiruddin Sheriff, Director, NCAA</p>
            <p> ✬ Representative of local society- Mr. K Allauddin, IAS</p>
            <p>
              {" "}
              ✬ Student representative, Shift-1- Mr. O. Mohamed Kasim, M.A.,
              English
            </p>
            <p>
              {" "}
              ✬ Student representative, Shift-2- Mr. S.E. Minhaaj, M.Sc.,
              Physics
            </p>
            <p></p>
            <h3>
              One nominee each from Employers /Industrialists/Stakeholders
            </h3>
            <p> ✬ Employer- Mr. Nasar Hussain Mohammed</p>
            <p> ✬ Industrialist- Mr. Ashfaque Ahmed Mecca</p>
            <p> ✬ Stakeholder - Parent- Dr. Fayaz Mohamed Bijli</p>
            <p></p>
            <h3>
              One of the senior teachers as the coordinator/Director of the IQAC
            </h3>
            <p>✬ Dr. Anvar Sadhath V, Associate Professor of English</p>
            <p></p>
            <h3>Technical Expert</h3>
            <p>✬ Mr. M. Thameemul Ansari, System and Web Administrator</p>
          </div>
        )}

        <button
          onClick={() => setFour((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2021 - 2022
        </button>
        {four && (
          <div className="obj-items">
            <h3>Chairperson: Head of the Institution</h3>
            <p>✬ Dr. S. Basheer Ahamed, Principal</p>
            <p></p>
            <h3>Members</h3>
            <p>
              ✬ Dr. G. Shaik Abdul Wahab - Associate Professor, Department of
              English
            </p>

            <p>
              ✬ Dr. T. Abdul Khadar - Associate Professor, Department of
              Historical Studies Dr. Mohammed Ibrahim Naveed - Associate
              Professor, Department of Zoology Dr. S. Thothadri - Assistant
              Professor, Department of Commerce
            </p>
            <p>
              ✬ Dr. J. Sulaiman - Assistant Professor, Department of Commerce
            </p>
            <p>
              ✬ Dr. M. Abdul Jamal - Assistant Professor, Department of
              Economics
            </p>
            <p>
              ✬ Mr. R. Sivakumar - Assistant Professor, Department of Business
              Administration Dr. Syed Shakir Razvi - Assistant Professor,
              Department of Corporate. Sec
            </p>
            <p>
              ✬ Dr. U. Muhammed Rafi - Assistant Professor, Department of
              Chemistry Dr. A. Shahul Hameed, Assistant Professor of English
            </p>
            <p>
              ✬ Mr. S. K. Akbar Basha, Assistant Professor of Computer Science
              Dr. M. R. Thameem Ansari, Assistant Professor of Arabic
            </p>
            <p>✬ Mr. S.M. Mohamed Lukman, Librarian</p>
            <p>✬ Dr. U. Muhammed Rafi, Assistant Professor of Chemistry</p>
            <p>✬ Dr. U. Mahaboob Basha, Director of Physical Education</p>
            <p></p>
            <h3>One member from the Management</h3>
            <p>✬ Mr. Elias Sait, Hon. Secretary</p>
            {/* <p>
                ✬ Mr. S. K. Akbar Basha, Assistant Professor of Computer Science</p>
              <p>
                ✬
                Dr. M. R. Thameem Ansari, Assistant Professor of Arabic</p>
              <p>
                ✬ Mr. S.M. Mohamed Lukman, Librarian</p>
              <p>
                ✬
                Dr. U. Mahaboob Basha, Director of Physical Education</p> */}
            <p></p>
            <h3>Few Senior administrative officers</h3>
            <p>
              ✬ VP Academic - Prof. S.A. Sheik Mohamed VP Admin - Dr. V. Kamal
              Nasir
            </p>
            <p>✬ COE - Prof. A.R. Abdul Lathif</p>
            <p>✬ Bursar - Dr. S. Syed Rafiq Ahmed</p>
            <p>
              ✬ Dean of Arts - Dr. S. Mohamed Abdul Razak Dean of Science - Dr.
              M.A. Mohamed Musthafa Dean of Commerce - Prof. K.S. Md Akmal Dean
              of Research - Dr. M. Gulam Mohamed
            </p>
            <p>✬ Vice-President, Student Affairs — Mr. Khaja Mohideen</p>
            <p>✬ Deputy Warden - Dr. A. Hyder Ali</p>
            <p>✬ Placement Officer - Dr. M. Ansar</p>
            <p>✬ Office Superintendent - Mr. M.H. Rasool Mohideen</p>
            <p></p>
            <h3>One nominee each from local society, Students and Alumni</h3>
            <p>
              {" "}
              ✬ Alumnus- Mr. M. Zahiruddin Sheriff, Director, NCAA
              Representative of local society- Mr. K Allauddin, IAS
            </p>

            <p>
              ✬ Student representative, Shift-l- Mr. J. Shaik Mustafa, B.Com.,
              Corporate Secretaryship Student representative, Shift-2- Mr. A.
              Mohamed Ibrahim, M.Sc., Physics
            </p>
            <p></p>
            <h3>
              One nominee each from Employers /Industrialists/Stakeholders
            </h3>
            <p>
              {" "}
              ✬ Employer- Mr. Nasar Hussain Mohammed Industrialist- Mr. Ashfaque
              Ahmed Mecca Stakeholder - Parent- Dr. Fayaz Mohamed Bijli
            </p>
            <p></p>
            <h3>
              One of the senior teachers as the coordinator/Director of the IQAC
            </h3>
            <p> ✬ Dr. Anvar Sadhath V, Associate Professor of English</p>

            <h3>Technical Expert</h3>
            <p>✬ Mr. M. Thameemul Ansari, System and Web Administrator</p>
          </div>
        )}

        <button
          onClick={() => setFive((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2022 - 2023
        </button>
        {five && (
          <div className="obj-items">
            <h3>Chairperson: Head of the Institution</h3>
            <p>✬ Dr. S. Basheer Ahamed, Principal</p>
            <p></p>
            <h3>Members</h3>
            <p>
              ✬ Dr. G. Shaik Abdul Wahab - Associate Professor, Department of
              English
            </p>

            <p>
              ✬ Dr. T. Abdul Khadar - Associate Professor, Department of
              Historical Studies
            </p>
            <p>
              ✬ Dr. Mohammed Ibrahim Naveed - Associate Professor, Department of
              Zoology
            </p>
            <p>
              ✬ Dr. S. Thothadri - Assistant Professor, Department of Commerce
            </p>
            <p>
              ✬ Dr. J. Sulaiman - Assistant Professor, Department of Commerce
            </p>
            <p>
              ✬ Dr. M. Abdul Jamal - Assistant Professor, Department of
              Economics
            </p>
            <p>
              ✬ Mr. R. Sivakumar - Assistant Professor, Department of Business
              Administration
            </p>
            <p>
              ✬ Dr. Syed Shakir Razvi - Assistant Professor, Department of
              Corporate. Secretaryship
            </p>
            <p>
              ✬ Dr. U. Muhammed Rafi - Assistant Professor, Department of
              Chemistry
            </p>
            <p>✬ Dr. A. Shahul Hameed - Assistant Professor of English</p>
            <p>
              ✬ Mr. S. K. Akbar Basha - Assistant Professor of Computer Science
            </p>
            <p>✬ Dr. M. R. Thameem Ansari - Assistant Professor of Arabic</p>
            <p>✬ Mr. S.M. Mohamed Lukman - Librarian</p>
            <p>✬ Dr. U. Mahaboob Basha - Director of Physical Education</p>
            <p></p>
            <h3>One member from the Management</h3>
            <p>✬ Mr. Elias Sait, Hon. Secretary</p>
            <p></p>
            <h3>Few Senior administrative officers</h3>
            <p>✬ Mr. Elias Sait, Hon. Secretary</p>
            {/* <p>
                ✬ Mr. S. K. Akbar Basha, Assistant Professor of Computer Science</p>
              <p>
                ✬
                Dr. M. R. Thameem Ansari, Assistant Professor of Arabic</p>
              <p>
                ✬ Mr. S.M. Mohamed Lukman, Librarian</p>
              <p>
                ✬
                Dr. U. Mahaboob Basha, Director of Physical Education</p> */}
            <p></p>
            <h3>Few Senior administrative officers</h3>
            <p>✬ Vice-Principal Academic - Prof. S.A. Sheik Mohamed</p>
            <p>✬ Vice-Principal Admin - Dr. V. Kamal Nasir</p>
            <p>✬ Controller of Examinations - Prof. A.R. Abdul Lathif</p>
            <p>✬ Bursar - Dr. S. Syed Rafiq Ahmed</p>
            <p>✬ Dean of Biological Science - Dr. M. Asrar Sheriff</p>
            <p>✬ Dean of Commerce and Management - Prof. K.S. Md Akmal</p>
            <p>
              ✬ Dean of Language and Literature - Dr. S. Mohamed Abdul Razak
            </p>
            <p>
              ✬ Dean of Physical and Chemical Science - Dr. M.A. Mohamed
              Musthafa
            </p>
            <p>✬ Dean of Commerce and Management - Prof. K.S. Md Akmal</p>
            <p>✬ Dean of Computational Science - Mr. A. Faiz Ahamed</p>
            <p>
              ✬ Dean of Humanities and Social Science - Dr. S. Kareemulla Basha
            </p>
            <p>✬ Dean of Research - Dr. M. Gulam Mohamed</p>
            <p>✬ Vice-President, Student Affairs - Mr. Khaja Mohideen</p>
            <p>✬ Deputy Warden - Dr. A. Hyder Ali</p>
            <p>✬ Placement Officer - Dr. M. Ansar</p>
            <p>✬ Office Superintendent - Mr. M.H. Rasool Mohideen</p>
            <p></p>
            <h3>One nominee each from local society, Students and Alumni</h3>
            <p> ✬Alumnus- Mr. M. Zahiruddin Sheriff, Director, NCAA</p>

            <p>✬ Representative of local society- Mr. K Allauddin, IAS</p>
            <p>✬ Student representative, Shift-1-</p>
            <p>✬ Student representative, Shift-2-</p>
            <p></p>
            <h3>
              One nominee each from Employers /Industrialists/Stakeholders
            </h3>
            <p>✬ Employer- Mr. Nasar Hussain Mohammed</p>
            <p>✬ Industrialist- Mr. Ashfaque Ahmed Mecca</p>
            <p>✬ Stakeholder - Parent- Dr. Fayaz Mohamed Bijli</p>
            <p></p>
            <h3>
              One of the senior teachers as the coordinator/Director of the IQAC
            </h3>
            <p> ✬ Dr. Anvar Sadhath V, Associate Professor of English</p>

            <h3>Technical Expert</h3>
            <p>✬ Mr. M. Thameemul Ansari, System and Web Administrator</p>
          </div>
        )}

        <button
          onClick={() => setSix((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Composition of IQAC for the Academic Year 2023 - 2024
        </button>
        {six && (
          <div className="obj-items">
            <h3>Chairperson</h3>
            <p>✬ Dr. M. Asrar Sheriff - Principal</p>
            <p></p>
            <h3>Director of the IQAC</h3>
            <p>✬ Dr. Anvar Sadhath V, Associate Professor of English</p>
            <p></p>
            <h3>Members</h3>
            <p>✬ Dr. V. Kamal Nasir, Associate Professor of Mathematics</p>

            <p>
              ✬ Dr. T. Abdul Khadar, Coordinator IQAC & Associate Professor of
              History
            </p>
            <p>✬ Dr. A. Shahul Hameed, Associate Professor of English</p>
            <p>✬ Dr. M. Abdul Jamal, Associate Professor of Economics</p>
            <p>✬ Dr. U. Muhammed Rafi, Assistant Professor of Chemistry</p>
            <p>
              ✬ Dr. Syed Shakir Razvi, Assistant Professor of Corporate
              Secretaryship
            </p>
            <p>
              ✬ Mr. R. Sivakumar, Assistant Professor of Business Administration
            </p>
            <p>
              ✬ Mr. S. K. Akbar Basha, Assistant Professor of Computer Science
            </p>
            <p>✬ Dr. M. R. Thameem Ansari, Assistant Professor of Arabic</p>
            <p>✬ Mr. M. Thameemul Ansari, Assistant Professor of Sociology</p>

            <p></p>
            <h3>One member from the Management</h3>
            <p>✬ Mr. Elias Sait, Hon. Secretary & Correspondent</p>
            <p></p>
            <h3>Few Senior administrative officers</h3>
            <p>✬ Vice Principal Academic - Prof. K.S. Md Akmal</p>
            <p>✬ Vice Principal Administration - Dr. P. A. Abdullah Mahaboob</p>
            <p>✬ Controller of Examinations - Dr. T. K. Shabeer</p>
            <p>✬ Dean of Research - Dr. M. Gulam Mohamed</p>
            <p>✬ Dean of Student Affairs - Mr. Khaja Mohideen</p>
            <p>✬ UGC Grants Coordinator - Dr. Mohammed Ibrahim Naveed</p>
            <p>✬ College Council Secretary - Dr. S. Tameem Sharief</p>
            <p>✬ Deputy Warden - Dr. A. Hyder Ali</p>
            <p>✬ IIEC Director - Dr. M. Nizam Mohideen</p>
            <p>✬ NCSS Director - Dr. J. Sulaiman</p>
            <p>✬ Placement Officer - Dr. M. Ansar</p>
            <p>✬ Office Superintendent - Mr. M.H. Rasool Mohideen</p>
            <p></p>
            <h3>One nominee each from Local society, Students and Alumni</h3>
            <p>✬ Alumnus- Mr. M. Zahiruddin Sheriff, Director, NCAA (NCAA)</p>
            <p>✬ Representative of local society - Justice (Retd.) Akbar Ali</p>
            <p>
              ✬ Student representative, Shift-I- Mr. Umar Mukhthar. S.N., III
              B.Sc. Mathematics
            </p>
            <p>
              ✬ Student representative, Shift-2- Mr. Abdul Malik. Y, III B.Com.
              (General)
            </p>

            <p></p>
            <h3>
              One nominee each from Employers /Industrialists/Stakeholders
            </h3>
            <p>✬ Industrialist- Mr. Ashfaque Ahmed Mecca</p>

            <p>✬ Employer- Mr. Nasar Hussain Mohammed</p>
            <p>✬ Stakeholder - Parent- Prof. S.A. Sheik Mohamed</p>

            <p></p>
            <h3>Technical Expert</h3>
            <p>
              ✬ Mr. A. Arshad Ahmed, System Assistant, Department of Computer
              Science
            </p>
            <p>
              ✬ Mr. F. Mohammed Arshad, System Assistant, Department of
              Information Technology
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default IQACCoreCommitteMembers;
